import React, { useEffect } from "react";
import { Box, Stack, Chip, Button, IconButton, Grid, Typography, useTheme, Collapse } from "@mui/material";
import Divider from '@mui/material/Divider';
//Controls
//Icons
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
//Components
import { tokens } from "../../../assets/theme";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import messages from "../messages";

const OrderList = (props) => {

    //console.log("OrderList", props.filteredData);
    
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [showChildrenFor, setShowChildrenFor] = useState(0);
    const [showOrderrowsFor, setshowOrderrowsFor] = useState(0);
    const { formatMessage } = useIntl();

    let slim = props.slim;

    const handleShowChildrenClick = (id) => {
        if (id === showChildrenFor) {
            id = 0;
        }
        setShowChildrenFor(id);
    }

    const handleShowOrderrowsClick = (id) => {
        if (id === showOrderrowsFor) {
            id = 0;
        }
        setshowOrderrowsFor(id);
    }

    function formatDateTimeFromTick(date) {
        let datePart = date ? new Date(date * 1000).toLocaleDateString('sv-SE') : "";
        let timePart = date ? new Date(date * 1000).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : "";
        return datePart + " " + timePart;
    }
    function formatDateFromTick(date) {
        let datePart = date ? new Date(date * 1000).toLocaleDateString('sv-SE') : "";
        return datePart;
    }
    function formatUnknown(value) {

        let article = value.reeltype?.reeltype1 || value.article?.drumtype;
        return article ? article : value.article?.description;
    }
    function getManufacturer(data, id) {
        let manufacturer = data?.find(x => x.id === id);
        return manufacturer?.manufacturer1 || "?";
    }
    function getDrumCount(data) {
        let filtered = data?.filter(x => x.article?.articleType !== 'FRA' && x.article?.articleType !== 'DES');
        return filtered?.filter(x => x.drumcount > 0).reduce((a, b) => parseInt(a) + parseInt((b['drumcount'] || 0)), 0);
    }

    function getCustomerBold() {
        return props.sortBy === "customer" ? { fontWeight: 'bold' } : { fontWeight: 'normal' };
    }

    function getReturnPointBold() {
        return props.sortBy === "returnpoint" ? { fontWeight: 'bold' } : { fontWeight: 'normal' };
    }

    function getTransporterBold() {
        return props.sortBy === "transporter" ? { fontWeight: 'bold' } : { fontWeight: 'normal' };
    }

    function getSelectedCustomerColor(customerId, selectedCustomerId) {
        return customerId === selectedCustomerId ? colors.primary[800] : colors.primary[400];
    }

    function getStatusText(status) {
        let statusText = "";
        switch (status) {
            case 1:
                statusText = formatMessage(messages.general_status1);
                break;
            case 2:
                statusText = formatMessage(messages.general_status2);
                break;
            case 999:
                statusText = formatMessage(messages.general_status999);
                break;
            case 3:
                statusText = formatMessage(messages.general_status3);
                break;
            case 4:
                statusText = formatMessage(messages.general_status4);
                break;
            case 9:
                statusText = formatMessage(messages.general_status9);
                break;
            case 10:
                statusText = formatMessage(messages.general_status10);
                break;
            default:
                statusText = formatMessage(messages.general_statusDefault);
                break;
        }

        return statusText;
    }

    function getBGColor(status) {
        let color = "";

        switch (status) {
            case 1:
                color = "#ffeb3b"; //yellow
                break;
            case 2:
                color = "#009688"; //teal
                break;
            case 999:
                color = "#ff9800"; //orange
                break;
            case 3:
                color = "#ff9800"; //orange
                break;
            case 4:
                color = "#4caf50"; //green
                break;
            case 9:
                color = "#4caf50"; //blue
                break;
            case 10:
                color = "#f30000"; //blue
                break;
            default:
                color = ""; //no color
                break;

            //color = "#2196f3"  //blue
        }
        return color;
    }

    function getColor(status) {
        if (status === 1) {
            return "";
        } else {
            return "#ffffff";//colors.greenAccent[500];
        }
    }

    function getCustomerCountList(data) {
        let customers = data?.map(x => x.customerid);

        let uniqueCustomers = [...new Set(customers)];

        let customerCount = uniqueCustomers.map(customer => {
            return { customer: customer, count: customers.filter(x => x === customer).length }
        });
        return customerCount;
    }

    let customers = props.filteredData?.map(x => x.customerid);
    function getOrderCount(customerId) {
        return customers.filter(x => x === customerId).length;
    }

    // console.log("Returns", props.data?.filter(x => x.statusid === 2));
    //console.log("manufacturers", props.manufacturers);
    //console.log ("props.showOrder", props.showOrder);   

    //console.log("order.returndrums", props.filteredData);

    let lastCustomerId = 0;

    let content = <>
        <Box color={colors.primary[100]} height="800px" sx={{ overflow: 'auto' }}>
            {props.sortBy !== "customer" && slim && <Stack width="93%" direction="column" marginLeft="15px" marginBottom="15px">
                {props.filteredData?.map((order) => {
                    return (<Box marginBottom="5px" boxShadow={1} >
                        <Stack direction="row" backgroundColor={colors.primary[400]} width="100%">
                        <Box backgroundColor={getBGColor(order?.statusid)} width="5px"></Box>
                        <Box backgroundColor={props.showOrder.id === order.id ? "#ffffff" : colors.primary[400]} width="100%" onClick={() => props.handleShowOrder(order)}>
                            <Stack padding="5px" paddingLeft="10px" width="100%" direction="row" display="flex" alignItems="center">
                                {/* <Box padding="5px" width="60px"><Button onClick={() => { handleShowChildrenClick(order.returnid) }} ><RemoveRedEyeOutlinedIcon sx={{ color: "#ffffff" }} /></Button>  </Box> */}
                                <Box width="60%">
                                    <Box width="1" display="flex" justifyItems="flex-start" alignContent="flex-start" style={getCustomerBold()} >{order.customer.customername}</Box>
                                    <Box width="1" display="flex" justifyItems="flex-start" alignContent="flex-start">{order.returnid}  </Box>
                                </Box>
                                <Box padding="5px" width="40%" justifyContent="flex-end" display="flex"><Chip key={9} label={getStatusText(order?.statusid)} size='small' sx={{ backgroundColor: getBGColor(order?.statusid), color: getColor(order?.statusid) }} /></Box>
                            </Stack>
                            <Stack padding="5px" paddingLeft="10px" width="100%" direction="row" display="flex" spacing="auto" alignItems="center">
                                <Box width="1">{formatDateFromTick(order.created)}  </Box>
                                <Box width="1"><FormattedMessage {...messages.orderList_items} />: {getDrumCount(order.returndrums)}  </Box>
                            </Stack>
                        </Box>
                        </Stack>
                    </Box>)
                })}
            </Stack>}

            {props.sortBy !== "customer" && !slim && <Stack width="98%" direction="column" marginLeft="15px" marginBottom="15px" >

                {props.filteredData?.map((order) => {
                    return (<Box marginBottom="5px" boxShadow={1}>
                        <Stack direction="row" backgroundColor={colors.primary[400]} width="100%">
                            <Box backgroundColor={getBGColor(order?.statusid)} width="5px"></Box>
                            <Box width="100%">
                                <Stack paddingTop="5px" paddingLeft="10px" width="100%" direction="row" display="flex" spacing="auto" alignItems="center" onClick={() => props.handleShowOrder(order)}>
                                    {/* <Box padding="5px" width="60px"><Button onClick={() => { handleShowChildrenClick(order.returnid) }} ><RemoveRedEyeOutlinedIcon sx={{ color: "#ffffff" }} /></Button>  </Box> */}
                                    <Box padding="5px" width="25%" display="flex" justifyItems="flex-start" style={getCustomerBold()} >{order.customer.customername} - {order.customer.id}</Box>
                                    <Box padding="5px" width="25%">{order.returnid}  </Box>
                                    <Box padding="5px" width="35%">{formatDateTimeFromTick(order.created)}  </Box>
                                    <Box padding="5px" width="15%"><FormattedMessage {...messages.orderList_items} />: {getDrumCount(order.returndrums)}  </Box>
                                   
                                </Stack>
                                <Stack paddingLeft="15px" width="100%" direction="row" backgroundColor={colors.primary[400]} display="flex" spacing="auto" alignItems="center" paddingBottom="5px" onClick={() => props.handleShowOrder(order)}>
                                    <Stack paddingBottom="5px" width="25%" display="flex" justifyItems="flex-start" direction="column"><Box><FormattedMessage {...messages.orderList_returnPoint} />:</Box><Box style={getReturnPointBold()} >{order.returnpoint.pointname}</Box></Stack>
                                    <Stack paddingBottom="5px" width="25%" display="flex" justifyItems="flex-start" ><Box><FormattedMessage {...messages.orderList_transportCompany} />:</Box><Box style={getTransporterBold()}>{order.pickupdata?.transportCompany?.name}</Box></Stack>
                                    <Box paddingBottom="5px" width="35%" display="flex" justifyItems="flex-start" ><FormattedMessage {...messages.orderList_pickupPoint} />:<br />{order.pickupdata?.location}</Box>
                                    <Box padding="5px" width="15%"><Chip key={9} label={getStatusText(order?.statusid)} size='small' sx={{ backgroundColor: getBGColor(order?.statusid), color: getColor(order?.statusid) }} /></Box>
                                </Stack>
                                <Divider color="#bbbbbb" />
                                <Stack width="100%" direction="row" backgroundColor={colors.primary[400]} display="flex" spacing="1" color="#000000" alignItems="center" overflow="auto" onClick={() => { handleShowChildrenClick(order.returnid) }} >
                                    <Box pwidth="60px"><Button onClick={() => { handleShowChildrenClick(order.returnid) }} ><RemoveRedEyeOutlinedIcon sx={{ color: colors.primary[100] }} /></Button>  </Box>
                                    {order.returndrums.filter(x => x.drumcount > 0).map((drum) => {
                                        return (<>
                                            <Box padding="3px" color={colors.primary[200]} paddingRight="15px">{formatUnknown(drum)}: {drum.drumcount}</Box>
                                        </>)
                                    })}
                                </Stack>
                            </Box>
                        </Stack>

                        {showChildrenFor === order.returnid && <Box>

                            {order.returndrums.filter(x => x.drumcount > 0).map((drum) => {
                                return (<>
                                    <Stack paddingRight="10px" paddingLeft="5px" width="100%" direction="row" backgroundColor={colors.primary[900]} display="flex" spacing="5px" color={colors.primary[100]}>
                                        {/* <Box padding="5px" backgroundColor={colors.primary[300]} width="20%">Drum id: {drum.id}  </Box> */}
                                        <Box padding="5px" width="40px" display="flex" justifyContent="flex-end">{drum.drumcount}  </Box>
                                        <Box padding="5px" width="1" display="flex" justifyItems="flex-start" justifyContent="flex-start">{drum.reeltype?.reeltype1 || drum.article?.drumtype}</Box>

                                        <Box padding="5px" width="1"><FormattedMessage {...messages.orderList_manufacturer} />: {getManufacturer(props.manufacturers, drum.manufacturerid)}  </Box>
                                    </Stack>
                                </>)
                            })}
                        </Box>}
                    </Box>)
                })}

            </Stack>
            }
            {/* </Collapse> */}
            {/* Customer centric */}

            {props.sortBy === "customer" && !slim && <Stack width="98%" direction="column" marginLeft="15px" marginBottom="15px">

                {props.filteredData?.map((order) => {

                    // boxShadow={1}
                    let res = (<><Box >
                        <Box backgroundColor={getSelectedCustomerColor(order.customer.id, showOrderrowsFor)} width="100%">
                            {/* onClick={() => props.handleShowOrder(order)} */}

                            {lastCustomerId !== order.customer.id &&
                                <>
                                    <Divider color="#ffffff" />
                                    <Stack paddingTop="5px" paddingLeft="10px" width="100%" direction="row" display="flex" spacing="auto" alignItems="center" onClick={() => { handleShowOrderrowsClick(order.customer.id) }}>
                                        {/* <Box padding="5px" width="60px"><Button onClick={() => { handleShowChildrenClick(order.returnid) }} ><RemoveRedEyeOutlinedIcon sx={{ color: "#ffffff" }} /></Button>  </Box> */}
                                        <Box padding="5px" width="50%" display="flex" justifyItems="flex-start"  >{order.customer.customername} - {order.customer.id}</Box>
                                        {/* <Box padding="5px" width="25%">{order.returnid}  </Box>
                                <Box padding="5px" width="25%">{formatDateTimeFromTick(order.created)}  </Box> */}
                                        <Box padding="5px" width="50%">Orders: {getOrderCount(order.customer.id)}  </Box>
                                    </Stack>
                                </>
                            }
                            {lastCustomerId !== order.customer.id &&
                                <>
                                    <Divider color="#bbbbbb" />
                                </>
                            }

                            {showOrderrowsFor === order.customer.id && <>
                                <Stack marginLeft="3px" marginRight="3px" paddingTop="5px" paddingLeft="10px" direction="row" display="flex" spacing="auto" alignItems="center" backgroundColor={colors.primary[400]} >
                                    {/* <Box padding="5px" width="60px"><Button onClick={() => { handleShowChildrenClick(order.returnid) }} ><RemoveRedEyeOutlinedIcon sx={{ color: "#ffffff" }} /></Button>  </Box> */}

                                    <Box padding="5px" width="25%"><b>{order.returnid}</b>  </Box>
                                    <Box padding="5px" width="25%">{formatDateTimeFromTick(order.created)}  </Box>
                                    <Box padding="5px" width="25%"><FormattedMessage {...messages.orderList_items} />: {getDrumCount(order.returndrums)}  </Box>
                                    <Box padding="5px" width="25%" display="flex" justifyItems="flex-end"  ><Chip key={9} label={getStatusText(order?.statusid)} size='small' sx={{ backgroundColor: getBGColor(order?.statusid), color: getColor(order?.statusid) }} /></Box>
                                </Stack>
                                <Stack marginLeft="3px" marginRight="3px" paddingLeft="15px" direction="row" backgroundColor={colors.primary[400]} display="flex" spacing="auto" alignItems="center" paddingBottom="5px" onClick={() => props.handleShowOrder(order)}>
                                    <Stack paddingBottom="5px" width="25%" display="flex" justifyItems="flex-start" direction="column"><Box><FormattedMessage {...messages.orderList_returnPoint} />:</Box><Box style={getReturnPointBold()} >{order?.returnpoint.pointname}</Box></Stack>

                                    <Stack paddingBottom="5px" width="25%" display="flex" justifyItems="flex-start" ><Box><FormattedMessage {...messages.orderList_transportCompany} />:</Box><Box style={getTransporterBold()}>{order?.pickupdata?.transportCompany?.name}</Box></Stack>
                                    <Box paddingBottom="5px" width="50%" display="flex" justifyItems="flex-start" ><FormattedMessage {...messages.orderList_pickupPoint} />:<br />{order?.pickupdata?.location}</Box>
                                    {/* <Box paddingBottom="5px" width="1" display="flex" justifyItems="flex-start" >  </Box> */}
                                </Stack>
                                <Divider color="#bbbbbb" />
                                <Stack marginLeft="3px" marginRight="3px" direction="row" backgroundColor={colors.primary[400]} display="flex" spacing="1" color="#000000" alignItems="center" overflow="auto" onClick={() => { handleShowChildrenClick(order.returnid) }} >
                                    <Box pwidth="60px"><Button onClick={() => { handleShowChildrenClick(order.returnid) }} ><RemoveRedEyeOutlinedIcon sx={{ color: colors.primary[100] }} /></Button>  </Box>
                                    {order.returndrums.map((drum) => {
                                        return (<>
                                            <Box padding="3px" color={colors.primary[100]} paddingRight="15px">{formatUnknown(drum)}: {drum.drumcount}</Box>
                                        </>)
                                    })}
                                </Stack>
                                <Divider color="#bbbbbb" />
                                <Divider color="#bbbbbb" />
                                <Divider color="#bbbbbb" />
                            </>}
                        </Box>
                        {showChildrenFor === order.returnid && <Box>

                            {order.returndrums.map((drum) => {
                                return (<>
                                    <Stack paddingRight="10px" paddingLeft="5px" width="100%" direction="row" backgroundColor={colors.primary[900]} display="flex" spacing="5px" color={colors.primary[100]}>
                                        {/* <Box padding="5px" backgroundColor={colors.primary[300]} width="20%">Drum id: {drum.id}  </Box> */}
                                        <Box padding="5px" width="40px" display="flex" justifyContent="flex-end">{drum.drumcount}  </Box>
                                        <Box padding="5px" width="1" display="flex" justifyItems="flex-start" justifyContent="flex-start">{drum.reeltype?.reeltype1 || drum.article?.drumtype}  </Box>

                                        <Box padding="5px" width="1"><FormattedMessage {...messages.orderList_manufacturer} />: {getManufacturer(props.manufacturers, drum.manufacturerid)}  </Box>
                                    </Stack>
                                </>)
                            })}
                        </Box>}

                    </Box>

                    </>
                    );

                    lastCustomerId = order.customer.id;
                    return res;

                })

                }

            </Stack>

            }

            {props.sortBy === "customer" && slim && <Stack width="95%" direction="column" marginLeft="15px" marginBottom="15px">

                {props.filteredData?.map((order) => {

                    // boxShadow={1}
                    let res = (<><Box >
                        <Box backgroundColor={getSelectedCustomerColor(order.customer.id, showOrderrowsFor)} width="100%">
                            {/* onClick={() => props.handleShowOrder(order)} */}

                            {lastCustomerId !== order.customer.id &&
                                <>
                                    <Divider color="#ffffff" />
                                    <Stack paddingTop="5px" paddingLeft="10px" width="100%" direction="row" display="flex" spacing="auto" alignItems="center" onClick={() => { handleShowOrderrowsClick(order.customer.id) }}>
                                        <Box padding="5px" width="80%" display="flex" justifyItems="flex-start"  >{order.customer.customername}</Box>
                                        <Box padding="5px" width="20%"> {getOrderCount(order.customer.id)}  </Box>
                                    </Stack>
                                </>
                            }
                            {lastCustomerId !== order.customer.id &&
                                <>
                                    <Divider color="#bbbbbb" />
                                </>
                            }

                            {showOrderrowsFor === order.customer.id && <>
                                <Stack marginLeft="5px" paddingTop="5px" paddingLeft="10px" width="98%" direction="column" display="flex" spacing="1px" alignItems="flex-start" backgroundColor={props.showOrder.id === order.id ? "#ffffff" : colors.primary[400]} onClick={() => props.handleShowOrder(order)}>
                                    {/* <Box padding="5px" width="60px"><Button onClick={() => { handleShowChildrenClick(order.returnid) }} ><RemoveRedEyeOutlinedIcon sx={{ color: "#ffffff" }} /></Button>  </Box> */}

                                    <Stack height="25%" direction="row" width="100%">
                                        <Box width="60%"><b>{order.returnid}</b></Box>
                                        <Box width="40%" display="flex" justifyContent="flex-end" paddingRight="15px"><Chip key={9} label={getStatusText(order?.statusid)} size='small' sx={{ backgroundColor: getBGColor(order?.statusid), color: getColor(order?.statusid) }} /></Box>
                                    </Stack>
                                    <Box height="25%">{formatDateFromTick(order.created)}  </Box>
                                    <Box height="25%"><FormattedMessage {...messages.orderList_items} />: {getDrumCount(order.returndrums)}  </Box>
                                    <Box height="25%"><FormattedMessage {...messages.orderList_returnPoint} />: {order.returnpoint.pointname}</Box>

                                </Stack>
                                <Divider color="#bbbbbb" />

                                <Divider color="#bbbbbb" />

                            </>}
                        </Box>
                        {showChildrenFor === order.returnid && <Box>

                            {order.returndrums.map((drum) => {
                                return (<>
                                    <Stack paddingRight="10px" paddingLeft="5px" width="98%" direction="row" backgroundColor={colors.greenAccent[900]} display="flex" spacing="5px" color={colors.primary[100]}>
                                        {/* <Box padding="5px" backgroundColor={colors.primary[300]} width="20%">Drum id: {drum.id}  </Box> */}
                                        <Box padding="5px" width="40px" display="flex" justifyContent="flex-end">{drum.drumcount}  </Box>
                                        <Box padding="5px" width="1" display="flex" justifyItems="flex-start" justifyContent="flex-start">{drum.reeltype?.reeltype1 || drum.article?.drumtype}  </Box>

                                        <Box padding="5px" width="1"><FormattedMessage {...messages.orderList_manufacturer} />: {getManufacturer(props.manufacturers, drum.manufacturerid)}  </Box>
                                    </Stack>
                                </>)
                            })}
                        </Box>}

                    </Box>

                    </>
                    );

                    lastCustomerId = order.customer.id;
                    return res;

                })

                }

            </Stack>

            }


        </Box>
    </>;

    return (
        <>
            {content}
        </>
    )
};

export default OrderList;
